import { useDispatch } from 'react-redux';

import { openInNewTab } from '@app/redux/utils';

import GooglePlayStoreSVG from './assets/google';

import styles from './styles.module.scss';

export const GooglePlayStoreButton = ({ url }: { url: string }): JSX.Element => {
  const dispatch = useDispatch();

  const onClick = () => {
    dispatch(openInNewTab(url));
  };

  return (
    <button onClick={onClick} data-cy="google-play-store-button" className={styles['appStoreButton']}>
      <GooglePlayStoreSVG />
    </button>
  );
};

export default GooglePlayStoreButton;
